import CostHTMLPreviewBaseColumnsStrategy from './CostHTMLPreviewBaseColumnsStrategy'

export default function CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype = new CostHTMLPreviewBaseColumnsStrategy();

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.init = function({timeFormat, showSpentTime, showAverageRates, showOthers})
{
    CostHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat, showSpentTime, showAverageRates );
    this.showOthers = showOthers
    return this;
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getTopLevelNameKey = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function( row )
{
    this.addOverallHeaderCells( row );
    var colSpan = 1;
    if( this.showSpentTime )
        colSpan++;
    if( this.isShowRatesForTopLevel() )
        colSpan++;

    this.addCell( row, this.message( this.getTopLevelNameKey() ), this.getTopLevelHeaderCellClassName(), colSpan, 2 );

    const topLevelName = this.showOthers ? this.message("report.common.others") : this.message(this.getTopLevelNameKey())
    this.addCell(row, topLevelName, this.getTopLevelHeaderCellClassName(), colSpan, 2)
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function( row )
{
    // do nothing
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function( row )
{
    for( var i = 0; i < 2; i++ )
    {
        if( this.showSpentTime )
            this.addCell( row, this.message( "report.cost.spent" ), "spent" );
        if( this.isShowRatesForTopLevel() )
            this.addCell( row, this.message( "report.cost.rate" ), "rate" );
        this.addCell( row, this.message( "report.cost.cost" ), "cost" );
    }
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addDataCells = function( row )
{
    this.addOverallDataCells( row );
    for( var i = 0; i < 2; i++ )
    {
        if( this.showSpentTime )
            this.addTimeValueCell( row );
        if( this.isShowRatesForTopLevel() )
            this.addMoneyValueCell( row );
        this.addCostDataCell( row );
    }
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getDataColumnsCount = function()
{
    var oneGroupCount = 1;
    if( this.showSpentTime ) oneGroupCount++;
    if( this.isShowRatesForTopLevel() ) oneGroupCount++;
    return this.getOverallColumnsCount() + oneGroupCount * 2;
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.areThereTwoRowsInHeader = function ()
{
    return true;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.js